import store from "./store";
import differenceInCalendarMonths from "date-fns/difference_in_calendar_months";
import format from "date-fns/format";
import idLocale from "date-fns/locale/id";
import addDays from "date-fns/add_days";
import addMonths from "date-fns/add_months";
import distanceInWords from "date-fns/distance_in_words";
import parse from "date-fns/parse";
import isWithinRange from "date-fns/is_within_range";
import isAfter from "date-fns/is_after";
import isBefore from "date-fns/is_before";
import addHours from "date-fns/add_hours";

/* eslint-disable */
export const isCan = perm => {
  if (!perm) return true;
  if (perm == "-") return false;
  if (perm === true || perm == false) return true;

  let permission = store.getters["user/permission"];

  const objPerm = permission.find(permission => permission.nama === perm);

  // eslint-disable-next-line
  if (objPerm) {
    return objPerm.value;
  } else {
    return false;
  }

  //eslint-disable-next-line
  let _m = perm.split("|");
  let _r = false;
  _m.forEach(p => {
    _r = _r || p == "*" || permission.filter(i => i.permission === p && i.value).length > 0;
    if (_r) return;
  });
  return _r;
};

export const normParam = (param, auto = true) => {
  // eslint-disable-next-line

  let par = param
    ? Object.keys(param)
        .filter(key => param[key] !== "" && param[key] !== null && param[key] !== undefined)
        .map(key => key + "=" + param[key])
        .join("&")
    : "";
  // par ? `?${par}` : ''
  if (par && auto) par = `?${par}`;
  return par;
};

export const monthBetween = (start, end) => {
  const s = new Date(start);
  const e = new Date(end);
  return differenceInCalendarMonths(e, s) + (e >= s ? 1 : 0);
};

export const toDT = value => {
  var formatTanggal = "dddd, DD-MM-YYYY HH:mm";
  // if (value.includes("00:00:00") || value.includes("23:59")) {
  //   formatTanggal = "dddd, DD-MM-YYYY";
  // };
  // UTC
  if (!value) return "";
  if (value == "-") return value;
  var clientTimezoneOffset = new Date(value).getTimezoneOffset() / 60;

  if (clientTimezoneOffset == -9) {
    var resWit = addHours(value, 2);
    var tzWit = format(resWit, formatTanggal, {
      locale: idLocale
    });
    return tzWit + (formatTanggal != "dddd, DD-MM-YYYY HH:mm" ? " WIT" : " WIT");
  } else if (clientTimezoneOffset == -8) {
    var resWita = addHours(value, 1);
    var tzWita = format(resWita, formatTanggal, {
      locale: idLocale
    });
    return tzWita + (formatTanggal != "dddd, DD-MM-YYYY HH:mm" ? " WITA" : " WITA");
  } else {
    var resWib = addHours(value, 0);
    var tzWib = format(resWib, formatTanggal, {
      locale: idLocale
    });

    return tzWib + (formatTanggal != "dddd, DD-MM-YYYY HH:mm" ? " WIB" : " WIB");
  }
};

export const toST = value => {
  if (value) {
    const parts = value.split(":");
    return +parts[0] + ":" + parts[1] + "";
  } else {
    return "00:00";
  }
};

export const toD = value => {
  if (!value) return "";
  return format(value, "dddd, DD-MM-YYYY", {
    locale: idLocale
  });
};

export const toSD = value => {
  if (!value) return "";
  return format(value, "DD-MM-YYYY", {
    locale: idLocale
  });
};

export const toYM = value => {
  if (!value) return "";
  return format(value, "YYYY-MM", {
    locale: idLocale
  });
};

export const toMMY = value => {
  if (!value) return "";
  return format(value, "MMMM YYYY", {
    locale: idLocale
  });
};

export const addM = addMonths;

export const deltaDTW = (a, b) =>
  distanceInWords(a, b, {
    locale: idLocale
  }) + " yang lalu";
export const deltaDTWN = a =>
  distanceInWords(a, new Date(), {
    locale: idLocale
  }) + " yang lalu";

export const groupBy = (array, key) => {
  const result = {};
  array.forEach(item => {
    if (!result[item[key]]) {
      result[item[key]] = [];
    }
    result[item[key]].push(item);
  });
  return result;
};

export const strToArrayObj = (o, prop) => {
  let arr = o[prop] || "";
  if (arr) {
    arr = arr.split(",").map(i => +i);
  } else {
    arr = [];
  }
  o[prop] = arr;
  return o;
};

export const pVal = (obj, a, b = undefined, c = undefined) => {
  let r = "-";
  if (!obj) return r;
  if (!obj[a]) return "-";
  r = obj[a];
  if (typeof b == "undefined") return r;
  if (!r[b]) return "-";
  r = r[b];
  if (typeof c == "undefined") return r;
  if (!r[c]) return "-";
  r = r[c];
  return r;
};

export const obj2KeyVal = (obj, key = "name", val = "value") => {
  return Object.keys(obj).map(k => ({
    [key]: k,
    [val]: [obj[k]]
  }));
};

export const serverTime = res => {
  var _dt = res.headers["date"];
  var _st = parse(_dt + "+0000");
  return _st;
};

export const checkKelasRunningST = (st, kelas) => {
  var _st = st;
  var _start = parse(kelas.tanggal_mulai + " GMT+0700");
  var _end = parse(kelas.tanggal_selesai + " GMT+0700");
  return isWithinRange(_st, _start, _end);
};

export const checkKelasRunningMaxDate = (st, start, max) => {
  var _st = parse(st + " GMT+0700");
  var _start = parse(start + " GMT+0700");
  var _maxeditable = addDays(_start, 2);
  return isBefore(_st, _maxeditable) ? true : false;
};

export const checkKelasRunning = (res, kelas) => {
  var _st = serverTime(res);
  var _start = parse(kelas.tanggal_mulai + " GMT+0700");
  var _end = parse(kelas.tanggal_selesai + " GMT+0700");
  return isWithinRange(_st, _start, _end);
};

export const checkKelasRunningWithTime = (st, kelas) => {
  var _st = st;
  var _start = parse(kelas.waktu_mulai + " GMT+0700");
  var _end = parse(kelas.waktu_selesai + " GMT+0700");
  return isWithinRange(_st, _start, _end);
};

export const parseIsWithinRange = (dt, start, end) => {
  var _start = parse(start + " GMT+0700");
  var _end = parse(end + " GMT+0700");
  return isWithinRange(dt, _start, _end);
};

export const parseIsAfter = (date1, date2) => {
  return isAfter(date1, date2);
};

export const parse0 = date1 => {
  return parse(date1 + "+0000");
};

export const parse7 = date1 => {
  return parse(date1 + " GMT+0700");
};

export const combineWaktu = (tanggal, waktu) => {
  return parse(parse(tanggal + "T" + waktu + "+07:00"));
};

export const parseIsBefore = (date1, date2) => {
  return isBefore(date1, date2);
};
